import { addDays, startOfDay } from "date-fns";

const DATE_RANGE_STORAGE_KEY = "tinyDateRangePicker_selectedRange";

export const saveDateRangeToStorage = (range: {
  startDate: Date;
  endDate: Date;
}) => {
  try {
    const rangeToStore = {
      startDate: range.startDate.toISOString(),
      endDate: range.endDate.toISOString(),
    };
    localStorage.setItem(DATE_RANGE_STORAGE_KEY, JSON.stringify(rangeToStore));
  } catch (error) {
    console.warn("Failed to save date range to localStorage:", error);
  }
};

export const loadDateRangeFromStorage = (): {
  startDate: Date;
  endDate: Date;
} | null => {
  try {
    const storedRange = localStorage.getItem(DATE_RANGE_STORAGE_KEY);
    if (storedRange) {
      const parsed = JSON.parse(storedRange);
      return {
        startDate: new Date(parsed.startDate),
        endDate: new Date(parsed.endDate),
      };
    }
  } catch (error) {
    console.warn("Failed to load date range from localStorage:", error);
  }
  return null;
};

export const getInitialDateRange = (fallbackRange?: {
  startDate: Date;
  endDate: Date;
}) => {
  const savedRange = loadDateRangeFromStorage();
  if (savedRange && savedRange.startDate && savedRange.endDate) {
    return savedRange;
  }

  if (fallbackRange) {
    return fallbackRange;
  }

  // Default 7-day range
  return {
    startDate: startOfDay(new Date()),
    endDate: startOfDay(addDays(new Date(), 7)),
  };
};
